import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Header from "../../components/Renewal/Header";
import _ from "lodash";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import TopBack from "../../components/Renewal/TopBack";
import driveBetter from "../../../assets/images/v3/drive_better.svg";

var formatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
});

const Policy = (props) => {
	let history = useHistory();
	const [drivers, setDrivers] = useState([]);
	const [cars, setCars] = useState([]);
	const [amount, setAmount] = useState([]);

	const renewalData = useSelector((state) => state.RenewalData);
	const renewalId = useSelector((state) => state.RenewalId);
	const loading = useSelector((state) => state.LoadingPage);
	const signData = useSelector((state) => state.SignData);
	const customerName = props.customerName;
	const dispatch = useDispatch();

	useEffect(() => {
		if (renewalId) {
			if (signData.signed_url === "") {
				fetch(`/api/v2/hello_sign/${renewalId}`)
					.then((res) => res.json())
					.then((res) => {
						dispatch({
							type: "SET_SIGN_DATA",
							payload: res,
						});
					});
			}
			fetch(`/api/v2/quotes/${renewalId}`)
				.then((res) => res.json())
				.then((res) => {
					dispatch({
						type: "SET_QUOTE_DATA",
						payload: res.quote,
					});
				});
		}
	}, [renewalId]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		if (renewalData) {
			setAmount(renewalData.amount);
			setDrivers(renewalData.drivers);
			setCars(renewalData.cars);
		}
	}, [renewalData]);

	const [name, lastName] = customerName.split(" ");

	return (
		<>
			{loading ? (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						paddingTop: "24px",
					}}
				>
					<Spinner
						animation="border"
						style={{ height: "4rem", width: "4rem" }}
					/>
				</div>
			) : (
				<>
					<div className="policy general d-flex justify-content-center">
						<div className=" otcontainer1 nopadding">
							<div className="col otmt-4">
								<h1 className="" style={{ color: "#00778a" }}>
									Hello {name}!
								</h1>

								<p className="otmt-1">Has it been a year already?</p>
								<p className="otmt-1">
									We hope you've gotten to spend plenty of time on the track and
									that OpenTrack will continue to help you not only DRIVE MORE,
									but DRIVE BETTER.
								</p>
								<p className="otmt-1">
									To continue the same great coverage, select 'RENEW POLICY
									AS-IS'. If you need to update driver, car or liability
									preferences, select 'RENEW WITH CHANGES'.
								</p>
							</div>
							<div className="justify-content-lg-center">
								<div className="col otmt-4">
									<div className="card">
										<div className="card-body">
											<div className="row justify-content-center">
												<h3 className="col-11 col-lg-11 pl-lg-0 otmt-1">
													Physical Damage Protection
												</h3>
												<div className="col-11 pl-lg-0 d-md-flex">
													<div className="d-flex">
														<p className="font-weight-bold text-uppercase">
															Starts:
														</p>
														<p className="ml-1">
															{moment(renewalData.policy_start).format(
																"MM-DD-YYYY"
															)}{" "}
															at 12:01am
														</p>
													</div>
													<div className="d-flex">
														<p className="ml-md-4 font-weight-bold text-uppercase">
															Ends:
														</p>
														<p className="ml-1">
															{moment(renewalData.policy_end).format(
																"MM-DD-YYYY"
															)}{" "}
															at 12:01am
														</p>
													</div>
												</div>
												<div className="col-11 pl-lg-0 d-flex">
													<p className="font-weight-bold text-uppercase">
														Drivers:
													</p>

													<p className="ml-lg-2">
														{drivers
															.map(
																(driver, i) =>
																	`${driver.first_name} ${driver.last_name}`
															)
															.join(", ")}
													</p>
												</div>
											</div>
											<div className="justify-content-lg-start ml-1 ml-lg-3 row">
												{cars.map((car, i) => (
													<div
														className="car-card col-11 col-lg-10 pl-0 pr-0 ml-2 ml-lg-0 otmt-1"
														key={i}
													>
														<h3
															className="col-12 ml-1 otmt-2"
															style={{ color: "#00788A" }}
														>
															{car.year} {car.make} {car.car_model}
														</h3>
														<div className="align-items-baseline d-flex ml-4">
															<p className="mb-0 font-weight-bold text-uppercase">
																COVERAGE VALUE:{" "}
															</p>
															<p className="ml-1 mb-0">
																{formatter.format(car.value)}
															</p>
														</div>
														<div className="align-items-baseline d-flex ml-4 otmb-2">
															<p className="mb-0 font-weight-bold text-uppercase">
																DEDUCTIBLE:{" "}
															</p>
															<p className="ml-1">
																{formatter.format(
																	(car.value * car.deductible_percentage) / 100
																)}{" "}
																({Math.round(car.deductible_percentage)}%)
															</p>
														</div>
													</div>
												))}
											</div>

											{_.get(renewalData, `liability_coverage`) ? (
												<div className="row">
													<div className="col-12 d-lg-flex flex-lg-wrap">
														<hr className="col-11 otmt-2 otmb-2" />
														<h3 className="col-11">Liability Protection</h3>
														<div className="col">
															<div className="d-flex">
																<p className="text-uppercase font-weight-bold mb-0">
																	Coverage Value:{" "}
																</p>
																<p className="ml-1 mb-0">
																	{formatter.format(
																		String(
																			_.get(
																				renewalData,
																				`liability_coverage`,
																				0
																			)
																		)
																	)}
																</p>
															</div>
															<div className="d-flex">
																<p className="text-uppercase font-weight-bold">
																	Deductible:{" "}
																</p>
																<p className="ml-1">{formatter.format(2500)}</p>
															</div>
														</div>
													</div>
												</div>
											) : null}

											{_.get(renewalData, `covers_misc_damage`) ? (
												<div className="row">
													<div className="col-12 d-lg-flex flex-lg-wrap">
														<hr className="col-11 otmt-2 otmb-2" />
														<h3 className="col-11">Misc Property Protection</h3>
														<div className="col">
															<div className="d-flex">
																<p className="text-uppercase font-weight-bold mb-0">
																	Coverage Value:{" "}
																</p>
																<p className="ml-1 mb-0">$1,000,000.00</p>
															</div>
															<div className="d-flex">
																<p className="text-uppercase font-weight-bold">
																	Deductible:{" "}
																</p>
																<p className="ml-1">{formatter.format(2500)}</p>
															</div>
														</div>
													</div>
												</div>
											) : null}

											<div className="row">
												<div className="col-12 d-lg-flex flex-lg-wrap">
													<hr className="col-11 otmt-2 otmb-2" />
													<div className="d-lg-flex ml-4">
														<img
															className="drivebetter mt-2"
															src={driveBetter}
															alt="..."
														/>
														<h3 className="mt-2 mt-md-0">
															Program Subscription
														</h3>
													</div>
													<p className="col-11">
														Exclusive access to webinars, track guides &
														training content
													</p>
													<p className="col-11 otmb-4">
														Included with annual coverage
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-12 d-flex flex-column flex-md-row justify-content-around mb-5 otmt-2">
								<Link
									className="btn btn-danger btn-italic btn-lg mb-4 mb-md-0"
									to={`/v3/renewals/${renewalId}/react/checkout`}
								>
									<span className="t8 mx-4 my-3">RENEW POLICY AS-IS</span>
								</Link>
								<Link
									className="btn btn-danger btn-italic btn-lg"
									to={`/v3/renewals/${renewalId}/react/renewal`}
								>
									<span className="t8 mx-4 my-3">RENEW WITH CHANGES</span>
								</Link>
							</div>
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default Policy;
